import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    beneficiaryData: {},
    beneficiaryInsertedData: {},
    selectedBeneficiaryId:null,
    beneficiaryByIdData:{},
    selectedBeneficiary: null,
    loading: false,
    error: null
};

export const beneficiarySlice = createSlice({
    name: 'beneficiary',
    initialState,
    reducers: {
        beneficiarySuccess: (state, action) => {
            state.beneficiaryData = action.payload;
            state.loading = false;
            state.error = null;
        },
        beneficiaryReset: (state) => {
            state.beneficiaryData = {};
            state.loading = false;
            state.error = null;
        },
        beneficiaryLoading: (state) => {
            state.loading = true;
            state.error = null;
        },
        beneficiaryError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        beneficiaryInsertSuccess: (state, action) => {
            state.beneficiaryInsertedData = action.payload;
            state.loading = false;
            state.error = null;
        },
        getBeneficiaryByIdSuccess: (state, action) => {
            console.log("Saving Beneficiary By ID:", action.payload);
            state.beneficiaryByIdData = action.payload;
        },
        beneficiaryInsertReset: (state) => {
            state.beneficiaryInsertedData = {};
            state.beneficiaryByIdData = {};
            state.selectedBeneficiary = null;
            state.loading = false;
            state.error = null;
        },
        selectBeneficiary: (state, action) => {
            state.selectedBeneficiary = action.payload;
        }
    }
});

// Export selector to access beneficiaryId from components
export const { 
    beneficiaryReset, 
    beneficiarySuccess, 
    beneficiaryLoading, 
    beneficiaryInsertSuccess, 
    beneficiaryInsertReset, 
    beneficiaryError,
    getBeneficiaryByIdSuccess,
    selectBeneficiary
} = beneficiarySlice.actions;

export default beneficiarySlice.reducer;